import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TagInput extends Component {
  state = {
    query: '',
    isInvalid: false,
  };

  handleChange = event => {
    this.setState({
      query: event.target.value,
      isInvalid: false,
    });
  };

  handleKeyDown = event => {
    // smart add for comma
    if (!['Enter', ','].includes(event.key)) {
      return;
    }

    event.preventDefault();
    this.handleAdd();
  };

  handleAdd = () => {
    const { options, useList, onAdd } = this.props;
    const { query } = this.state;
    const trimmedQuery = query.trim();

    if (!trimmedQuery) {
      return;
    }

    if (useList) {
      const match = options.find(option => option.toLowerCase() === trimmedQuery.toLowerCase());

      if (match) {
        onAdd(match);
        this.setState({ query: '', isInvalid: false });
      } else {
        this.setState({ isInvalid: true });
      }
    } else {
      onAdd(trimmedQuery);
      this.setState({ query: '', isInvalid: false });
    }
  };

  render() {
    const { useList, options, disabled, inputRef } = this.props;
    const { query, isInvalid } = this.state;

    return (
      <div className="relative flex-1">
        <input
          id="input-tag"
          type="text"
          data-test="input-tag"
          name="tags"
          list={useList ? 'input-tag-options' : undefined}
          placeholder={useList ? 'Search tags...' : 'Add tag...'}
          value={query}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          disabled={disabled || (useList && !options.length)}
          ref={inputRef}
          autoComplete="off"
          aria-invalid={isInvalid}
          className={`w-full bg-transparent border border-gray-300 rounded-md focus:ring-1 focus:ring-blue-500 text-sm py-1.5 px-2 outline-none transition-all ${
            isInvalid
              ? 'border-red-500 focus:border-red-500 focus:ring-red-200 bg-red-50 placeholder:text-red-300'
              : ''
          }`}
        />

        {useList && (
          <datalist id="input-tag-options">
            {options.map(option => (
              <option key={option} value={option} />
            ))}
          </datalist>
        )}
      </div>
    );
  }
}

TagInput.propTypes = {
  useList: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  onAdd: PropTypes.func.isRequired,
};

TagInput.defaultProps = {
  useList: false,
  options: [],
  disabled: false,
};
